export interface GameStartupOptions<T> {
  webglSupported: boolean;
  createGame: () => T;
  showUnavailable: () => void;
}

/**
 * Starts the game only when its rendering context is available.
 *
 * Browser and device policy can still reject a WebGL context after a support
 * probe succeeds, so construction is kept inside the same guarded path.
 */
export function startGame<T>({
  webglSupported,
  createGame,
  showUnavailable,
}: GameStartupOptions<T>): T | null {
  if (!webglSupported) {
    showUnavailable();
    return null;
  }

  try {
    return createGame();
  } catch {
    showUnavailable();
    return null;
  }
}
